import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Organisation, OrganisationUnit } from '../../../Models/Common/Organisation';
import { User } from '../../../Models/FitnessBox/User';
import { NavService } from '../../../Services/nav.service';
import { AppContext } from '../../../Shared/common';
import { CookieManager } from '../../../Shared/cookieManager';
import { UserType } from '../../../Shared/enum';
import { Global } from '../../../Shared/global';
import { AuthService } from '../../../Services/auth.service';
import { OrgService } from '../../../Services/org.service';

@Component({
  selector: 'top-nav',
  templateUrl: './top-nav.component.html'
})
export class TopNavComponent implements OnInit {

  @Input() Corp: Organisation;
  @Input() LoggedInUser: User;
  selectedUnit: OrganisationUnit = null;
  isAdminUser: boolean = false;
  showBranchSelection: boolean = false;

  constructor(
    public navService: NavService,
    private appctx: AppContext,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private orgService: OrgService
  ) { }

  ngOnInit() {
    // Initialize from Global context (legacy ASPX mode)
    this.Corp = Global.CurrentOrg;
    this.LoggedInUser = Global.CurrentUser;

    // If Global context is empty, try to get from AppContext
    if (!this.Corp || !this.Corp.OrgId) {
      this.Corp = this.appctx.CurrentOrg;
    }

    // If still empty, try to get from AuthService (new Angular auth mode)
    if (!this.Corp || !this.Corp.OrgId) {
      const authOrg = this.authService.getCurrentOrganization();
      if (authOrg) {
        this.Corp = this.convertAuthOrgToAppOrg(authOrg);
      }
    }

    if (!this.LoggedInUser || !this.LoggedInUser.ID) {
      this.LoggedInUser = this.appctx.CurrentUser;
    }

    // If still empty, try to get from AuthService
    if (!this.LoggedInUser || !this.LoggedInUser.ID) {
      const authUser = this.authService.getCurrentUser();
      if (authUser) {
        this.LoggedInUser = authUser as any;
      }
    }

    // Only initialize if we have valid data
    if (this.Corp && this.Corp.OrgId && this.LoggedInUser && this.LoggedInUser.ID) {
      this.SetInitValues();
    } else {
      console.warn('TopNavComponent: Organization or User data not available');
    }
  }

  /**
   * Convert AuthService Organization to AppOrganization format
   */
  private convertAuthOrgToAppOrg(authOrg: any): Organisation {
    const org = new Organisation();
    org.OrgId = authOrg.orgId;
    org.OrgName = authOrg.orgName;
    //org.OrgCode = authOrg.orgCode;
    org.IsActive = authOrg.isActive;
    org.OrgUnits = authOrg.units.map(unit => ({
      UnitId: unit.unitId,
      UnitName: unit.unitName,
      IsSelected: unit.isSelected || true
    }));
    return org;
  }

  logout() {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: (error) => {
        console.error('Logout error:', error);
        this.router.navigate(['/login']);
      }
    });
  }

  SetInitValues() {
    // Safe null check before accessing OrgUnits
    if (!this.Corp || !this.Corp.OrgUnits || this.Corp.OrgUnits.length === 0) {
      console.warn('SetInitValues: No organization units available');
      return;
    }

    for (var i = 0; i < this.Corp.OrgUnits.length; i++) {
      if (this.Corp.OrgUnits[i].IsSelected) {
        this.selectedUnit = this.Corp.OrgUnits[i];
        this.updateCookie();
      }
    }
    
    this.showBranchSelection = this.Corp.OrgUnits.length > 1;

    // Safe null check for user type
    if (this.LoggedInUser && this.LoggedInUser.UserType) {
      this.isAdminUser = (this.LoggedInUser.UserType == UserType.ADMIN || this.LoggedInUser.UserType == UserType.OWNER);
    }
  }

  changeBranch(value) {
    // Safe null checks before accessing properties
    if (!this.Corp || !this.Corp.OrgUnits) {
      console.warn('changeBranch: Organization units not available');
      return;
    }

    let unit: OrganisationUnit = <OrganisationUnit>value;
    this.selectedUnit = null;

    for (var i = 0; i < this.Corp.OrgUnits.length; i++) {
      this.Corp.OrgUnits[i].IsSelected = (this.Corp.OrgUnits[i].UnitId == unit.UnitId);
      
      // Safe access to appctx.CurrentOrg.OrgUnits
      if (this.appctx.CurrentOrg && this.appctx.CurrentOrg.OrgUnits) {
        this.appctx.CurrentOrg.OrgUnits[i].IsSelected = (this.Corp.OrgUnits[i].UnitId == unit.UnitId);
      }

      if (this.Corp.OrgUnits[i].UnitId == unit.UnitId) {
        this.selectedUnit = this.Corp.OrgUnits[i];
      }
    }
    this.updateCookie();
    this.orgService.setCurrentOrganization(this.Corp);

    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  updateCookie() {
    // Safe null check before updating cookie
    if (this.selectedUnit && this.selectedUnit.UnitId) {
      let cookieMan: CookieManager = new CookieManager();
      cookieMan.setCookie("SelectedUnit", this.selectedUnit.UnitId.toString(), 2);
    }
  }
}
